module.exports = __webpack_public_path__ + "images/CompleteProfileImage_6618e14.svg";